var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_449_17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4369 4.07134C19.8016 3.99392 21.1647 4.00012 22.5294 4.00012C22.5388 4.00012 29.4447 4.00012 29.4447 4.00012C30.8361 4.00012 32.1992 3.99392 33.5631 4.07134C34.8031 4.14102 36.011 4.28967 37.2133 4.6218C39.7443 5.32012 41.9545 6.7787 43.5522 8.84657C45.1404 10.9013 46 13.4166 46 15.9993C46 18.5852 45.1404 21.099 43.5522 23.1537C41.9545 25.2208 39.7443 26.6801 37.2133 27.3784C36.011 27.7106 34.8031 27.8584 33.5631 27.9289C32.1992 28.0063 30.8361 27.9993 29.4714 27.9993C29.462 27.9993 22.5545 28.0001 22.5545 28.0001C21.1647 27.9993 19.8016 28.0063 18.4369 27.9289C17.1976 27.8584 15.9898 27.7106 14.7875 27.3784C12.2565 26.6801 10.0463 25.2208 8.44863 23.1537C6.86039 21.099 6 18.5852 6 16.0001C6 13.4166 6.86039 10.9013 8.44863 8.84657C10.0463 6.7787 12.2565 5.32012 14.7875 4.6218C15.9898 4.28967 17.1976 4.14102 18.4369 4.07134Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 26C23.5228 26 28 21.5228 28 16C28 10.4772 23.5228 6 18 6C12.4772 6 8 10.4772 8 16C8 21.5228 12.4772 26 18 26Z",
    fill: "#272B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_449_17",
    x: 0,
    y: 0,
    width: 52,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_449_17"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_449_17",
    result: "effect2_dropShadow_449_17"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_449_17",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOff);
export default __webpack_public_path__ + "static/media/switch-off.ce7e9856e57868ed0eb20a41164dff1c.svg";
export { ForwardRef as ReactComponent };